import React from 'react';
import BrandJoinList from '../BrandJoinList';

const BrandJoinListWrap = (props) => {
  const { brandJoinList, getList, getExcelDownload } = props;

  return (
    <div className="brand-permit-list-wrap">
      {/* 입점승인 리스트 */}
      <BrandJoinList brandJoinList={brandJoinList} getList={getList} getExcelDownload={getExcelDownload} />
    </div>
  );
};

export default BrandJoinListWrap;
